/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const createLoopRequestSchema = z.object({
  name: z.string(),
});
